import React from 'react';
import { Database, FileText, Loader2 } from 'lucide-react';

const CollectionList = ({ collections, selectedCollection, onSelectCollection, loading }) => {
  return (
    <div className="h-full flex flex-col">
      <div className="p-4 border-b border-neutral-200 dark:border-neutral-700 flex items-center">
        <h3 className="text-sm font-medium text-ui-text-primary flex items-center">
          <Database size={16} className="mr-2" />
          Collections
        </h3>
      </div>

      <div className="flex-1 overflow-y-auto">
        {loading ? (
          <div className="flex items-center justify-center p-4">
            <Loader2 className="w-5 h-5 animate-spin text-ui-text-secondary" />
          </div>
        ) : collections.length === 0 ? (
          <div className="p-4 text-center text-ui-text-secondary text-sm">
            No collections found
          </div>
        ) : (
          <div className="p-2">
            {collections.map((collection) => (
              <button
                key={collection.name}
                onClick={() => onSelectCollection(collection)}
                className={`w-full text-left px-3 py-2 rounded-md mb-1 transition-colors flex items-center justify-between group ${
                  selectedCollection?.name === collection.name
                    ? 'bg-slate-200 dark:bg-neutral-700 text-ui-text-primary font-medium shadow-sm'
                    : 'hover:bg-neutral-100 dark:hover:bg-neutral-700 text-ui-text-primary'
                }`}
              >
                <div className="flex items-center min-w-0">
                  <FileText size={14} className="mr-2 flex-shrink-0" />
                  <span className="text-sm truncate">{collection.name}</span>
                </div>
                <div className="flex items-center text-xs text-ui-text-secondary ml-2">
                  <span>{collection.documentCount || 0}</span>
                </div>
              </button>
            ))}
          </div>
        )}
      </div>

      <div className="p-3 border-t border-neutral-200 dark:border-neutral-700">
        <div className="text-xs text-ui-text-secondary">
          {collections.length} collection{collections.length !== 1 ? 's' : ''}
        </div>
      </div>
    </div>
  );
};

export default CollectionList; 